import React from "react";

interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  priority?: boolean;
  height?:string;
  width?:string;
}

const Image: React.FC<ImageProps> = ({ src, alt, className, style, priority,height="100%",width="100%" }) => {
  const combinedClassName = `object-cover ${className || ""}`;

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        ...style,
      }}
    >
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        className={combinedClassName}
        style={{ width: height, height: width, objectFit: "cover" }}
      />
    </div>
  );
};

export default Image;
